import { LanguagesEnum } from '../enums/Languages';

export interface Language {
  code: string;
  name: string;
  flag: string;
}

export const SYSTEM_LANGUAGES = Object.values(LanguagesEnum);

export const languages: Language[] = [
  {
    code: LanguagesEnum.Turkish,
    name: 'Türkçe',
    flag: '/flags/tr.svg',
  },
  {
    code: LanguagesEnum.English,
    name: 'English',
    flag: '/flags/gb.svg',
  },
  {
    code: LanguagesEnum.Azerbaijan,
    name: 'Azerbaycan dili',
    flag: '/flags/az.svg',
  },
  {
    code: LanguagesEnum.Russian,
    name: 'Русский язык',
    flag: '/flags/ru.svg',
  },
  {
    code: LanguagesEnum.Kyrgyz,
    name: 'Кыргыз тили',
    flag: '/flags/kg.svg',
  },
  {
    code: LanguagesEnum.Uzbek,
    name: 'Ozbek tili',
    flag: '/flags/uz.svg',
  },
  {
    code: LanguagesEnum.Kazakh,
    name: 'Қазақ тілі',
    flag: '/flags/kz.svg',
  },
];
